import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";

function SupportPage() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { name, email, phone, message, subject } = formData;

    if (!name || !email || !phone || !message || !subject) {
      toast.error("All fields are required.");
      return;
    }

    if (!/^\S+@\S+\.\S+$/.test(email)) {
      toast.error("Invalid email format.");
      return;
    }

    if (!/^\d{10}$/.test(phone)) {
      toast.error("Phone number must be 10 digits.");
      return;
    }

    try {
      const response = await fetch("https://v2vbn.org//contact.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.status === "success") {
        toast.success("Support request submitted successfully.");
        setFormData({
          name: "",
          phone: "",
          email: "",
          subject: "",
          message: "",
        });
      } else {
        toast.error(result.message || "Submission failed.");
      }
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="support-page">
      <ToastContainer position="top-right" autoClose={3000} />

      <section className="support-header text-center py-10 bg-light">
        <div className="container">
          <h2 className="mb-3"> Here to Support Your Business, Every Step of the Way</h2>
          <p className="lead mb-3">
         

          Our dedicated support team is committed to delivering prompt, reliable assistance to keep your operations running smoothly. Whether it's a quick question or a complex issue, we’re here to help you move forward with confidence.
          </p>
            <a
              className="contact-here"
              href="mailto:webmaster@v2vbn.org"
            >
              <h3 className="">Support: webmaster@v2vbn.org</h3>
            </a>  
        </div>
      </section>

      <section className="support-form-section py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <form
                className="bg-white p-4 shadow rounded"
                onSubmit={handleSubmit}
              >
                <div className="contact-form-wrapper row">
                  <div className="col-lg-6">
                    <div className="form-group">
                      <input
                        className="input-field"
                        name="name"
                        placeholder="Name"
                        type="text"
                        value={formData.name}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <input
                        className="input-field"
                        name="phone"
                        placeholder="Phone"
                        type="text"
                        value={formData.phone}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <input
                        className="input-field"
                        name="email"
                        placeholder="Email"
                        type="email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <input
                        className="input-field"
                        name="subject"
                        placeholder="Subject"
                        type="text"
                        value={formData.subject}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="form-group">
                      <textarea
                        className="input-field"
                        name="message"
                        placeholder="How can we help"
                        value={formData.message}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  {/* CAPTCHA removed */}
                  <div className="col-lg-12">
                    <div className="form-submit-group">
                      <button className="tmp-btn btn-primary" type="submit">
                        Submit Now
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

     
    </div>
  );
}

export default SupportPage;
